/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/24/19
 * Time: 2:05 PM
 */
export const CLIENT_SECRET = "Y2V5ZW50cmE6"; // "Y2V5ZW50cmE6QXRBMWlmTTRoSzBzTUsyYWhpOEtScDF6aGlBWDE4YnJzNGo1MWl0MG00eWw2MkRBYTkydkEzV3M4UTgxS3RoNWFzTW4wcG01";
export const CLIENT_ID = "ceyentra";
export const GOOGLE_LOCATION_KEY = "AIzaSyD9Juj4XYGRnE19y6p6-urYftTDEEafGkU";
export const GOOGLE_SIGN_UP_ID = "40434516146-9jt20f50nvipfii0arijvfuafhccqq5k.apps.googleusercontent.com"
export const FACEBOOK_SIGN_UP_ID = "1080807272778497"
export const APPLE_SIGN_UP_ID = "com.ceyentra.miracledomelk"
export const APPLE_SIGN_UP_REDIRECT_URI = "https://web.icsi.lk/public/web-sign-up"
